import { render, staticRenderFns } from "./scim_token.vue?vue&type=template&id=479a6d28"
import script from "./scim_token.vue?vue&type=script&lang=js"
export * from "./scim_token.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports